import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const r = l((e, a) => /* @__PURE__ */ s.jsx(
  i,
  {
    ref: a,
    ...e,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4150)", children: [
            /* @__PURE__ */ s.jsxs(
              "mask",
              {
                id: "mask0_2974_4150",
                width: 32,
                height: 32,
                x: 8,
                y: 8,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M24.1 40h-.2C15.13 40 8 32.87 8 24.09V8.75c0-.41.34-.75.75-.75h30.5c.41 0 .75.34.75.75s-.34.75-.75.75H9.5v14.59c0 7.94 6.46 14.41 14.4 14.41h.19c7.94 0 14.4-6.46 14.4-14.41V11.92a.755.755 0 0 1 1.51 0V24.1C40 32.87 32.87 40 24.1 40"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M22.86 30.94c-.35 0-.66-.25-.73-.6-.04-.17-.92-4.29-4.9-5.11a.74.74 0 0 1-.58-.89.74.74 0 0 1 .89-.58c2.67.56 4.21 2.27 5.07 3.77.82-3.23 2.91-8.68 8.07-11.63a.74.74 0 0 1 1.02.28c.2.36.07.82-.29 1.02-6.8 3.88-7.8 12.97-7.81 13.06a.75.75 0 0 1-.71.67c-.01.01-.02.01-.03.01"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4150)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M.002-.006h48v48.034h-48z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4150", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
r.displayName = "AgencyCheckBadgeIcon";
export {
  r as AgencyCheckBadgeIcon,
  r as default
};
//# sourceMappingURL=index.js.map
